var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-accordion-item",class:{ 'app-accordion-item--dark': _vm.darkMode }},[_c('a',{staticClass:"app-accordion-item__title",on:{"click":_vm.toogle}},[_c('strong',[_vm._t("title")],2),_c('FontAwesomeIcon',{staticClass:"app-accordion-item__title__icon",class:{
        'app-accordion-item__title__icon--openned': _vm.openned,
        'app-accordion-item__title__icon--closing': _vm.closing
      },attrs:{"icon":"chevron-down"}})],1),_c('div',{staticClass:"app-accordion-item__content",class:{
      'app-accordion-item__content--openned': _vm.openned,
      'app-accordion-item__content--closing': _vm.closing
    }},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }